import React, { useMemo } from "react";
import { useNavigate } from "react-router";
import { SelectionLayoutProps } from "@companion-core/shared/app/Interfaces/blocks";
import { useDynamicPageStore } from "@companion-core/shared/app/Store/dynamicPageStore";
import { Button } from "@companion-core/shared/app/Components/Button";
import { ComponentCard } from "@companion-core/shared/app/Components/Cards/ComponentCard";
import { SelectionCommonLayout } from "@companion-core/shared/app/Components/Blocks/Layouts/SelectionCommonLayout/SelectionCommonLayout";
import { useMediaQuery } from "@companion-core/web/src/Utilities/mediaQuery";
import { redirectTo } from "@companion-core/web/src/Utilities/navigation";
import "@companion-core/web/src/Assets/Styles/scss/selectionPushLayout.scss";

export const SelectionPushLayout = ({
  text,
  cardList,
  button,
  blockSlug,
}: SelectionLayoutProps) => {
  const { pageSlug, blocksBySlug } = useDynamicPageStore();
  const colorIndex = useMemo(() => {
    return blocksBySlug[blockSlug ?? ""]?.isLoaded
      ? (blocksBySlug[blockSlug ?? ""].colorIndex ?? 0)
      : 0;
  }, [blocksBySlug, blockSlug]);
  const navigate = useNavigate();
  const isMobileSize = useMediaQuery("(max-width: 768px)");

  return (
    <div className={colorIndex % 2 === 0 ? "colored-background--odd" : "colored-background--even"}>
      {isMobileSize ? (
        <SelectionCommonLayout
          text={text}
          cardList={cardList}
          button={button}
          blockSlug={blockSlug}
        />
      ) : (
        <section className="selection-push-layout" data-testid="selection-push">
          {text && (
            <h2
              data-testid="selection-push__title"
              className="selection-push-layout__title super-title-3">
              {text.title}
            </h2>
          )}
          {text?.subtitle && (
            <span
              data-testid="selection-push__subtitle"
              className="selection-push-layout__subtitle title-8">
              {text.subtitle}
            </span>
          )}
          <div data-testid="selection-push__cards" className="selection-push-layout__cards">
            {cardList?.map((component, index) => {
              return (
                <ComponentCard
                  key={`selection-push-layout-card-${component.id}`}
                  component={component}
                  pageSlug={pageSlug ?? ""}
                  nbItems={cardList.length}
                  position={index}
                  url={window.location.href}
                  fixedHeight={true}
                />
              );
            })}
          </div>
          {button && button.button_title && (
            <Button
              testID="selection-push__cta"
              label={button.button_title}
              size="large"
              onClick={() =>
                redirectTo(button.button_link ?? "/", button?.button_type ?? "internal", navigate)
              }
            />
          )}
        </section>
      )}
    </div>
  );
};
